import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Modal, Button, Form, Navbar, Nav, Image, InputGroup } from 'react-bootstrap';
import Notification from './Notification';
import { persistor, RootState } from '../store';
import Category from './Category';
import { getCurrentUser, signOut } from 'aws-amplify/auth';
import Search from './Search';
import { useApi } from '../api/contexts/ApiContext';
import { useSelector } from 'react-redux';
import { logout } from '../store/auth/authSlice';
import { useDispatch } from 'react-redux';

interface HeaderProps {
  mode: string;
  vendor: {
    companyName: string | undefined;
    lastName: string | undefined;
    firstName: string | undefined;
  };
}

const Header: React.FC = () => {
  // const Header: React.FC<HeaderProps> = ({ mode, vendor }) => {
  const { userInfo } = useSelector((state: RootState) => state.auth);
  const { vendorInfo } = useSelector((state: RootState) => state.vendor);
  const [inputKeyword, setInputKeyword] = useState('');
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const urlQueryMode = queryParams.get('mode') == 'facility' ? 'facility' : 'company';
  const { keyword, category, search } = location.state || {};
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [username, setUsername] = useState<string>();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // const [page, setPage] = useState(1);
  // const PER_PAGE = 9;
  // const fromRecordNum = (PER_PAGE * page) - PER_PAGE;
  // const { getModule } = useApi();
  // const { userInfo, userToken, error } = useSelector((state: RootState) => state.auth);
  const handleKeywordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputKeyword(event.target.value);
  };

  // const handleCategoryChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   setCategory(event.target.value);
  // };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    // TODO: Implement search logic here
  };


  const handleLogout = async () => {
    try {
      dispatch(logout());
      await persistor.purge();
      await signOut({ global: true });
      navigate('/');
    } catch (error) {
      console.log('Error signing out: ', error);
    }
  }

  const handleFavorite = async () => {
    const params = new URLSearchParams();
    params.set("category", 'favorite');
    params.set("mode", urlQueryMode);
    navigate(`/search_result?${params.toString()}`);
  }

  const handleList = async () => {
    const params = new URLSearchParams();
    params.set("mode", urlQueryMode);
    navigate(`/search_result?${params.toString()}`);
  }

  // const getUsername = async () => {
  //   const username = vendor.lastName + '' + vendor.firstName;
  //   setUsername(username);
  // }
  // useEffect(() => {
  //   if (!username) {
  //     getUsername();
  //   }
  // })
  const handleKeywordDown = async (e: any) => {
    if (e.key === "Enter") {
      e.preventDefault();

      // URLクエリパラメータに両方入れる
      let query = `keyword=${encodeURIComponent(inputKeyword)}`;
      // if (category) {
      //   query += `&category=${encodeURIComponent(category)}`;
      // }

      navigate(`/search_result?${query}`, {
        state: {
          keyword: inputKeyword,
          // category: category
        }
      });
    }
  };

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const keywordFromUrl = query.get('keyword') || '';
    setInputKeyword(keywordFromUrl);
  }, [location.search]);


  const toggleNotifications = () => setShowNotifications(!showNotifications);

  return (
    <>
      <section className="header-section">
        <div className="container">
          <div className="my-auto float-sm-left logo-wrapper text-sm-left text-center">
            <Link className="navbar-brand" to="/mypage">
              <Image className="bid-logo" src="./assets/images/logo-bid.svg" alt="" />
            </Link>
          </div>
          <div className="my-auto nav-wrapper">
            <div className="row mx-0">
              <div className="col-sm-5 col-7 px-0">
                <div>{vendorInfo?.companyName ? vendorInfo?.companyName : '電力会社'}</div>
              </div>
              <div className="col-sm-7 col-5 px-0 text-right top-right-nav">

              </div>
              <div className="col-xl-5 col-lg-5 col-sm-10 col-5 px-0">
                <div>{vendorInfo?.last_name + '' + vendorInfo?.first_name} 様</div>
                <div className="search-section my-0">
                  <div className="d-flex justify-content-end">
                    <Button type="button" className="btn btn-secondary btn-sm rounded-pill mr-4 mb-2 px-3 nav-dropdown" onClick={() => setShowCategoryModal(true)}>カテゴリーから探す ▼</Button>
                  </div>
                  <Form id="search-form" onSubmit={handleSubmit}>
                    {/* <input type="hidden" name="mode" value={mode} onChange={handleCategoryChange} />
                    <input type="hidden" name="category" value={category} onChange={handleCategoryChange} /> */}
                    <div className="input-field new-design float-left mr-2 mb-md-0 mb-2">
                      <input type="text" id="keyword" name="keyword" value={inputKeyword} placeholder="案件名検索" className="form-control input-sm btn-sm nav-search rounded-pill" onChange={handleKeywordChange} onKeyDown={handleKeywordDown} />
                    </div>
                    <Button className="btn btn-secondary btn-sm rounded-pill ml-2 px-3 nav-dropdown"
                      onClick={() => setShowSearchModal(true)}>詳細検索 ▼</Button>
                  </Form>
                </div>
              </div>
              {/* <div className="col-xl-7 col-lg-7 col-sm-2 col-7 px-0 text-end">
                <Link className="text-blue-header ms-0" style={{ textDecoration: "none" }} to="#" onClick={handleLogout}>ログアウト</Link>

              </div> */}

              <div className="col-xl-7 col-lg-7 col-sm-2 col-7 px-0 text-end">
                <nav className="navbar navbar-expand-lg navbar-light bg-white fixed-top1 p-0" id="mainNav">
                  <button className="navbar-toggler navbar-toggler-end" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                  </button>

                  <div className="collapse navbar-collapse d-lg-block" id="navbarResponsive">
                    <ul className="navbar-nav ms-auto">
                      <li className="nav-item">
                        <a className="nav-link text-center" onClick={handleList} >
                          <Image fluid className="nav-icon header-icon" src="assets/images/header-icon-all.svg" alt="" />
                          <span className="nav-icon-text">案件一覧</span>
                        </a>
                      </li>
                      <li className="nav-item">
                        <Link className="nav-link text-center" to="/bidding">
                          <Image fluid className="nav-icon header-icon" src="assets/images/header-icon-medal.svg" alt="" />
                          <span className="nav-icon-text">応札情報</span>
                        </Link>
                      </li>
                      {/* <li className="nav-item">
                        <Link className="nav-link text-center" to="/win">
                          <Image fluid className="nav-icon header-icon" src="assets/images/header-icon-court-hammer.svg" alt="" />
                          <span className="nav-icon-text">落札履歴</span>
                        </Link>
                      </li> */}
                      <li className="nav-item" >
                        <a className="nav-link text-center" onClick={handleFavorite}>
                          {/* <Link className="nav-link text-center" state={{ category: "favorite" }} to={`/search_result?category=favorite`}> */}
                          <Image fluid className="nav-icon header-icon" src="assets/images/header-icon-star.svg" alt="" />
                          <span className="nav-icon-text">お気に入り</span>
                        </a>
                      </li>
                      <li className="nav-item">
                        <Link className="nav-link text-center" to="/report">
                          <Image fluid className="nav-icon header-icon" src="assets/images/header-icon-report.svg" alt="" />
                          <span className="nav-icon-text">レポート</span>
                        </Link>
                      </li>
                      {/* <li className="nav-item" onClick={toggleNotifications}>
                        <input id="navAction" value="0" readOnly type="hidden" />
                        <Link className="nav-link text-center" id="menuBell" to="#">
                          <Image fluid className="nav-icon header-icon" src="assets/images/header-icon-bell.svg" alt="" />
                          <span className="nav-icon-text">通知</span>
                        </Link>
                      </li> */}
                      <li className="nav-item last-nav-item d-flex flex-column align-items-center">
                        <Link
                          to="#"
                          onClick={handleLogout}
                          className="text-blue-header "
                          style={{
                            transform: "translateX(-50%)",
                            position: "absolute",
                            top: "-20px",
                            textDecoration: "none",
                            fontSize: "0.8rem",
                            fontWeight: "400",
                          }}
                        >
                          ログアウト
                        </Link>
                        <Link className="nav-link text-center pr-0" to="/account">
                          <Image fluid className="nav-icon header-icon" src="assets/images/header-icon-user.svg" alt="" />
                          <span className="nav-icon-text">マイアカウント</span>
                        </Link>

                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* {<Notification isOpen={showNotifications} />}
      {showNotifications && <div className="overlay" onClick={toggleNotifications}></div>} */}
      <Modal show={showCategoryModal} onHide={() => { setShowCategoryModal(false) }}>

      </Modal>
      <Modal size="xl" className="fade bd-example-modal-lg container-theme-modal" show={showSearchModal} onHide={() => { setShowSearchModal(false) }}>
        <Search onClose={() => { setShowSearchModal(false) }} />
      </Modal>
      <Modal size="xl" className="fade bd-example-modal-lg container-theme-modal" id="exampleModal1" tabindex="-1"
        show={showCategoryModal} onHide={() => { setShowCategoryModal(false) }}
        aria-labelledby="exampleModalLabel1" aria-hidden="true">
        <Category onClose={() => { setShowCategoryModal(false) }} />
      </Modal>

    </>
  );
};

export default Header;